export const seoConfig = {
  home: {
    title: "Stop Buying Tools. Start Deploying Agents. | Handvantage",
    description: "We deploy enterprise-secure, OpenClaw-powered security agents to map your attack surface and triage threats in milliseconds. We are the Pilot. They are the Fleet.",
    keywords: "agentic ai, automated security workforce, cybersecurity agents, openclaw framework, dual dna model, managed security services, ai pentesting, agentic detection and response, handvantage",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Handvantage",
      "url": "https://handvantage.co",
      "description": "Elite provider of autonomous AI security agents and 24/7 SOC services.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://handvantage.co/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }
  },
  about: {
    title: "About Josh Olayemi - Strategic Technology Consultant | 20+ Years Experience",
    description: "Meet Josh Olayemi, strategic technology consultant with 20+ years experience at Amazon, Oracle, and AWS. Expert in eliminating growth bottlenecks and creating competitive advantages.",
    keywords: "Josh Olayemi, strategic technology consultant, business growth strategist, AWS consultant, Oracle consultant, Amazon consultant, growth bottleneck expert, competitive advantage",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "ProfilePage",
      "mainEntity": {
        "@type": "Person",
        "name": "Josh Olayemi",
        "jobTitle": "Strategic Technology Consultant",
        "description": "Strategic technology consultant with 20+ years experience at Amazon, Oracle, and AWS",
        "image": "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753844826077-Olayemi-profile2-2023-jpg.webp",
        "worksFor": {
          "@type": "Organization",
          "name": "Handvantage"
        }
      }
    }
  },
  // Archived service SEO entries removed in S70 cleanup; routes redirected via netlify.toml
  assessment: {
    title: "Strategic Growth Assessment | Business Technology Evaluation | Handvantage",
    description: "Free strategic growth assessment that identifies technology bottlenecks limiting your business potential. Get expert recommendations for creating competitive advantages.",
    keywords: "strategic growth assessment, technology bottleneck analysis, business evaluation, competitive advantage assessment, strategic planning, growth strategy",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Strategic Growth Assessment",
      "description": "Free assessment to identify technology bottlenecks limiting business growth",
      "applicationCategory": "BusinessApplication"
    }
  },
  securityAssessment: {
    title: "Business Protection Assessment | Risk Analysis | Handvantage",
    description: "Comprehensive business protection assessment that identifies security vulnerabilities threatening your growth and provides strategic protection recommendations.",
    keywords: "business protection assessment, security risk analysis, vulnerability assessment, strategic protection planning, business continuity, risk mitigation strategy",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Business Protection Assessment",
      "description": "Comprehensive evaluation of business protection needs and strategic recommendations",
      "applicationCategory": "BusinessApplication"
    }
  },
  roiCalculator: {
    title: "Strategic Investment Calculator | Business Impact Analysis | Handvantage",
    description: "Calculate the strategic business impact of eliminating technology bottlenecks. Analyze ROI, payback period, and competitive advantages from strategic technology investments.",
    keywords: "strategic investment calculator, business impact analysis, ROI calculator, technology investment, growth strategy, competitive advantage analysis, strategic planning",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Strategic Investment Calculator",
      "description": "Interactive calculator for analyzing business impact of strategic technology investments",
      "applicationCategory": "BusinessApplication",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Free business impact analysis with detailed strategic roadmap"
      }
    }
  },
  securityMaturityAssessment: {
    title: "Cybersecurity Maturity Assessment | Security Posture Evaluation | Handvantage",
    description: "Comprehensive cybersecurity maturity assessment to evaluate your current security posture and receive personalized recommendations for improvement.",
    keywords: "cybersecurity maturity assessment, security posture evaluation, security assessment, cyber maturity, security recommendations, vulnerability assessment",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Cybersecurity Maturity Assessment",
      "description": "Comprehensive evaluation of your cybersecurity maturity level with personalized recommendations",
      "provider": {
        "@type": "Organization",
        "name": "Handvantage"
      }
    }
  },
  maturityRoadmap: {
    title: "Cybersecurity Maturity Roadmap Generator | Strategic Security Planning | Handvantage",
    description: "Generate a customized cybersecurity maturity roadmap based on your assessment results to guide your security improvement journey.",
    keywords: "cybersecurity roadmap, security maturity roadmap, security planning, cyber security strategy, security improvement plan",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Cybersecurity Maturity Roadmap",
      "description": "Customized roadmap for improving your cybersecurity maturity level",
      "provider": {
        "@type": "Organization",
        "name": "Handvantage"
      }
    }
  },
  complianceAssessment: {
    title: "Compliance Readiness Assessment | Regulatory Compliance Evaluation | Handvantage",
    description: "Evaluate your organization's readiness for various compliance frameworks including SOC 2, HIPAA, PCI DSS, and others.",
    keywords: "compliance assessment, regulatory compliance, SOC 2, HIPAA, PCI DSS, compliance readiness, compliance evaluation",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Compliance Readiness Assessment",
      "description": "Comprehensive evaluation of your compliance readiness across multiple frameworks",
      "provider": {
        "@type": "Organization",
        "name": "Handvantage"
      }
    }
  },
  budgetPlanner: {
    title: "Security Budget Planner | IT Security Budget Planning Tool | Handvantage",
    description: "Plan and optimize your cybersecurity budget with our comprehensive security budget planning tool and expert guidance.",
    keywords: "security budget planner, cybersecurity budget, IT security budget, security investment planning, budget optimization",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Security Budget Planner",
      "description": "Strategic planning tool for optimizing your cybersecurity budget and investments",
      "provider": {
        "@type": "Organization",
        "name": "Handvantage"
      }
    }
  },
  vendorEvaluation: {
    title: "Vendor Evaluation Matrix | Security Vendor Assessment Tool | Handvantage",
    description: "Comprehensive vendor evaluation matrix to help you select the best cybersecurity and technology vendors for your business needs.",
    keywords: "vendor evaluation, security vendor assessment, vendor selection, technology vendor evaluation, vendor comparison matrix",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Vendor Evaluation Matrix",
      "description": "Strategic tool for evaluating and selecting the best technology and security vendors",
      "provider": {
        "@type": "Organization",
        "name": "Handvantage"
      }
    }
  },
  privacyPolicy: {
    title: "Privacy Policy | Data Protection & Privacy | Handvantage",
    description: "Our privacy policy explains how we collect, use, and protect your information when you use our website and services, including text messaging.",
    keywords: "privacy policy, data protection, personal information, cookies, data security, GDPR, privacy rights",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Privacy Policy",
      "description": "Privacy policy explaining how we collect, use, and protect your information",
      "publisher": {
        "@type": "Organization",
        "name": "Handvantage"
      }
    }
  },
  termsConditions: {
    title: "Terms and Conditions | Legal Terms | Handvantage",
    description: "Terms and conditions governing your use of our website and services, including text messaging and all digital services.",
    keywords: "terms and conditions, legal terms, terms of service, user agreement, website terms, service terms",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Terms and Conditions",
      "description": "Terms and conditions governing the use of our website and services",
      "publisher": {
        "@type": "Organization",
        "name": "Handvantage"
      }
    }
  },
  manifesto: {
    title: "The Dual Squeeze Manifesto | Handvantage",
    description: "Why 'good security' is killing your business and how Viability Engineering solves the conflict between security pressure and speed pressure.",
    keywords: "dual squeeze manifesto, viability engineering, fortress vs factory, security speed balance, cybersecurity manifesto, business security strategy",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "The Dual Squeeze Manifesto: Why Good Security is Killing Your Business",
      "description": "An exploration of how modern firms are crushed between security pressure (The Fortress) and speed pressure (The Factory), and how Viability Engineering provides the solution",
      "author": {
        "@type": "Organization",
        "name": "Handvantage"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Handvantage",
        "logo": {
          "@type": "ImageObject",
          "url": "https://handvantage.co/logo.svg"
        }
      },
      "datePublished": "2026-01-22",
      "articleBody": "The Dual Squeeze Manifesto explains how modern businesses are crushed between two opposing forces: The Fortress (pressure to be secure) and The Factory (pressure to be fast). Viability Engineering is the solution that harmonizes these forces."
    }
  },
  aiWorkforce: {
    title: "AI Workforce - Deploy Autonomous Digital Employees | Handvantage",
    description: "Don't buy software. Hire digital employees. Deploy autonomous AI agents for sales (SDR), compliance (GRC), and support (L1-L2). Scale infinitely for a fraction of the cost of traditional hiring.",
    keywords: "AI workforce, agentic AI, digital employees, AI agents, AI SDR, AI compliance, AI support, autonomous agents, business automation AI, AI employees, digital workforce, LLM agents, OpenAI agents, Anthropic Claude agents",
    canonical: "/services/ai-workforce",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "AI Workforce - Agentic AI Deployment",
      "description": "Deploy autonomous AI agents that work 24/7 as digital employees for sales, compliance, and support operations",
      "provider": {
        "@type": "Organization",
        "name": "Handvantage",
        "url": "https://handvantage.co",
        "logo": "https://handvantage.co/logo.svg",
        "sameAs": [
          "https://linkedin.com/company/handvantage",
          "https://linkedin.com/in/josh-olayemi"
        ]
      },
      "serviceType": "AI Workforce Deployment",
      "category": "Artificial Intelligence Services",
      "areaServed": {
        "@type": "Country",
        "name": "United States"
      },
      "offers": {
        "@type": "AggregateOffer",
        "lowPrice": "3500",
        "highPrice": "10000",
        "priceCurrency": "USD",
        "priceSpecification": {
          "@type": "UnitPriceSpecification",
          "price": "6250",
          "priceCurrency": "USD",
          "unitText": "MONTH"
        }
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "AI Agent Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "The Hunter - AI SDR Agent",
              "description": "Autonomous AI agent that finds leads, researches pain points, writes personalized emails, and books meetings 24/7"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "The Sentry - AI Compliance Agent",
              "description": "AI agent that monitors logs in real-time, checks policies, and gathers SOC2/ISO audit evidence automatically"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "The Concierge - AI Support Agent",
              "description": "L1-L2 support AI agent that triages tickets, resets passwords, provisions access, solving 80% of requests instantly"
            }
          }
        ]
      }
    }
  }
};

// Organization Schema for AEO (AI Engine Optimization)
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Handvantage",
  "alternateName": "Handvantage AI Workforce Solutions",
  "url": "https://handvantage.co",
  "logo": "https://handvantage.co/logo.svg",
  "description": "Elite provider of autonomous AI security agents and 24/7 SOC services. Stop buying tools and start deploying an automated enterprise-secure workforce with zero data leakage.",
  "foundingDate": "2020",
  "founders": [
    {
      "@type": "Person",
      "name": "Josh Olayemi",
      "jobTitle": "Founder & Strategic Technology Consultant",
      "url": "https://linkedin.com/in/josh-olayemi"
    }
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "US",
    "addressRegion": "North America"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+1-236-235-0919",
    "contactType": "Sales",
    "areaServed": "US",
    "availableLanguage": "English"
  },
  "sameAs": [
    "https://linkedin.com/company/handvantage",
    "https://linkedin.com/in/josh-olayemi"
  ],
  "serviceArea": {
    "@type": "Country",
    "name": "United States"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Handvantage Services",
    "itemListElement": [
      {
        "@type": "OfferCatalog",
        "name": "AI Workforce Solutions",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "AI Workforce Deployment",
              "description": "Deploy autonomous AI agents for sales, compliance, and support"
            }
          }
        ]
      },
      {
        "@type": "OfferCatalog",
        "name": "Managed Security Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "24/7 SOC & MDR",
              "description": "24/7 Security Operations Center with active remediation and 15-minute response SLA"
            }
          }
        ]
      }
    ]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "12"
  }
};

// FAQ Schema for AI platforms
export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Agentic AI and how is it different from automation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Agentic AI refers to autonomous AI agents that can reason, plan, and execute tasks independently. Unlike traditional automation (like Zapier/Make scripts that follow 'if this, then that' logic), agentic AI agents can adapt to changing conditions, handle edge cases, and make decisions without human intervention. They use large language models (LLMs) to understand context and execute complex workflows."
      }
    },
    {
      "@type": "Question",
      "name": "How much does it cost to deploy AI agents compared to hiring employees?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A typical internal hire (like a Security Analyst or SDR) costs $180,000+ per year including salary and benefits, works 40 hours per week (2,080 hours/year), and may burn out in 6 months. Handvantage AI agents work 24/7/365 (8,760 hours/year), cost a fraction of the price (starting at $6,250/month), never burn out, and get smarter every day. The ROI is typically 3-5x within the first year."
      }
    },
    {
      "@type": "Question",
      "name": "What AI agents does Handvantage offer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Handvantage offers three core AI agents: 1) The Hunter (AI SDR) - finds leads, researches pain points, writes personalized emails, books meetings. 2) The Sentry (AI Compliance Agent) - monitors logs, checks policies, gathers SOC2/ISO evidence. 3) The Concierge (AI Support Agent) - triages tickets, resets passwords, provisions access, solves 80% of L1-L2 requests automatically."
      }
    },
    {
      "@type": "Question",
      "name": "Is Handvantage vendor agnostic for AI platforms?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Handvantage builds AI agents on OpenAI (GPT-4), Anthropic (Claude), or open-source models depending on your requirements. We are loyal to outcomes, not vendors. We select the best AI platform for each use case and can integrate with your existing tech stack."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to deploy AI agents?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our 4-step process typically takes 2-4 weeks: 1) Map - identify human bottlenecks (1 week), 2) Build - code the agents with custom Python + LLMs (1-2 weeks), 3) Train - load your knowledge base (2-3 days), 4) Deploy - agents start working on Day 1. Most clients see ROI within the first month."
      }
    },
    {
      "@type": "Question",
      "name": "What is the difference between Handvantage and traditional MSPs?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Traditional MSPs resell software and send alerts when something breaks. Handvantage is the service layer - we actively manage your systems 24/7 (we are the Pilot, not the copilot), deploy autonomous AI agents to replace expensive hires, and are vendor agnostic (we work with whatever tools you already have). We guarantee 15-minute response times and focus on outcomes, not tool sales."
      }
    }
  ]
};